export function purchaseOrderMasksConvert(purchaseOrderMask: string[]): string[] {
  const purchaseOrderMaskTemp: string[] = [];
  if (purchaseOrderMask) {
    purchaseOrderMask.forEach(POMaskPattern => {
      purchaseOrderMaskTemp.push(POMaskPattern.replace(/@/g, 'A').replace(/[+]/g, '1'));
    });
  }
  return purchaseOrderMaskTemp;
}
